module.exports = __webpack_public_path__ + "static/media/door0303.6e1435e4.jpg";